import { useMutation, useQueryClient } from 'react-query'
import { useTranslation } from 'react-i18next'

import { useDialog } from '@hapana/shared/web/components/shared/dialog/dialog.hooks'
import {
  createEquipmentAssignment,
  cancelEquipmentAssignment,
  createAddonInvoice,
} from '_services/tanning/equipment-assignments.service'
import { getEquipments, getEquipment } from '_services/tanning/equipments.service'
import { useToast } from '@hapana/shared/web/components/shared/toast/toast.hooks'
import { TOAST_PROPS_OPTIONS } from '@hapana/shared/web/components/shared/toast/toast.constants'

export const useCreateEquipmentAssignment = (options) => {
  useDialog()
  const queryClient = useQueryClient()

  const onSuccess = async (data, variables) => {
    const { siteId, equipmentId } = variables || {}
    if (siteId) {
      await queryClient.invalidateQueries([getEquipments.key, { siteId }])
    }
    if (siteId && equipmentId) {
      await queryClient.invalidateQueries([getEquipment.key, { siteId, equipmentId }])
    }
    options?.onSuccess?.(data)
  }

  const onError = (error) => {
    options?.onError?.(error)
  }

  return useMutation(createEquipmentAssignment, { ...options, onSuccess, onError })
}

export const useCreateAddonInvoice = (options) => {
  return useMutation(createAddonInvoice, { ...options })
}

export const useCancelEquipmentAssignment = (options) => {
  const { openToast } = useToast()
  const queryClient = useQueryClient()
  const { t } = useTranslation('checkIn')

  const onSuccess = async (data) => {
    const siteId = options?.siteId
    const equipmentId = options?.equipmentId
    if (siteId) {
      await queryClient.invalidateQueries([getEquipments.key, { siteId }])
    }
    if (siteId && equipmentId) {
      await queryClient.invalidateQueries([getEquipment.key, { siteId, equipmentId }])
    }
    openToast({
      title: t('checkIn:equipments.manageEquipments.timerStopped'),
      severity: TOAST_PROPS_OPTIONS.SEVERITY.SUCCESS,
      horizontal: TOAST_PROPS_OPTIONS.HORIZONTAL.CENTER,
    })
    options?.onSuccess?.(data)
  }

  const onError = (error) => {
    const errorMessage = error?.response?.errors?.[0]?.message
    openToast({
      title: errorMessage || t('checkIn:equipments.manageEquipments.failedToStopTimer'),
      severity: TOAST_PROPS_OPTIONS.SEVERITY.ERROR,
      horizontal: TOAST_PROPS_OPTIONS.HORIZONTAL.CENTER,
    })
    options?.onError?.(error)
  }

  return useMutation(cancelEquipmentAssignment, { ...options, onSuccess, onError })
}
